import WsProvider from './provider/WSProvider';

var serviceName = 'webservis';
var moduleName = 'proje';

var projeService = {
    imagePath: WsProvider.imagePath,
    imagePathBuyuk: WsProvider.imagePathBuyuk,
    imagePathOrta: WsProvider.imagePathOrta,
    imagePathKucuk: WsProvider.imagePathKucuk,
    belgePath: WsProvider.documentPath,
    path: WsProvider.path,

    projeListesi(durum, baslangic, limit) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[durum]': durum,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            serviceName: moduleName,
            methodName: 'projeListesi',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    projeDetay(projeID) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[projeID]': projeID,
            serviceName: moduleName,
            methodName: 'projeDetay',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    projeEkle({
                  musteriID,
                  not,
                  projeBaslik,
                  adresBaslik,
                  alan,
                  ada,
                  parsel,
                  durum,
                  yatirimTutari,
                  istihdamSayisi,
                  tarihler
              }) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[musteriID]': musteriID,
            'data[not]': not,
            'data[projeBaslik]': projeBaslik,
            'data[alan]': alan,
            'data[ada]': ada,
            'data[parsel]': parsel,
            'data[durum]': durum,
            'data[tutar]': yatirimTutari,
            'data[adres]': adresBaslik,
            'data[istihdamSayisi]': istihdamSayisi,
            'data[yonetimTarihi]': tarihler.yonetimTarihi || '',
            'data[tebligatTarihi]': tarihler.tebligatTarihi || '',
            'data[noterTarihi]': tarihler.noterTarihi || '',
            'data[arsaTahsisTarihi]': tarihler.arsaTahsisTarihi || '',
            'data[yapiRuhsatTarihi]': tarihler.yapiRuhsatTarihi || '',
            'data[isYeriAcmaRuhsatTarihi]': tarihler.isYeriAcmaRuhsatTarihi || '',
            methodName: 'projeEkle',
            serviceName: moduleName,
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    projeFilter(firmaAdi, projeBaslik, alan, ada, parsel, baslangicTarihi, bitisTarihi, durum, baslangic = 0, limit = 20) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[firmaAdi]': firmaAdi,
            'data[projeBaslik]': projeBaslik,
            'data[alan]': alan,
            'data[ada]': ada,
            'data[parsel]': parsel,
            'data[baslangicTarihi]': baslangicTarihi,
            'data[bitisTarihi]': bitisTarihi,
            'data[durum]': durum,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            serviceName: moduleName,
            methodName: 'projeArama',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    projeSayisi(durum) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            durum: durum,
            serviceName: moduleName,
            methodName: 'projeSayisi',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    projeGuncelle(data) {
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, data)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    toggleActivate(id, status) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[projeID]': id,
            'data[durum]': status,
            serviceName: moduleName,
            methodName: 'projeDurumDegistir',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
};

export default projeService;
